import axios from "axios";
import { RefreshToken } from "../services/RefreshToken";

const getToken = async () => {
  const { token, tokenExpiryDate, refreshTokenNum, refreshTokenExpiryDate } =
    getTokenData();

  if (!tokenExpiryDate || !refreshTokenNum || !refreshTokenExpiryDate)
    return "";

  if (
    isTokenExpired(tokenExpiryDate) 
  ) {
    const refreshToken = await RefreshToken(refreshTokenNum);
    if (!refreshToken?.data?.tokenNum) return "";

    setTokenData(
      refreshToken.data.tokenNum,
      refreshToken.data.tokenExpiryDate,
      refreshToken.data.refreshTokenNum,
      refreshToken.data.refreshTokenExpiryDate
    );
    return refreshToken.data.tokenNum;
  }

  return token;
};

const isTokenExpired = (tokenExpiryDate: string) =>
new Date(new Date(tokenExpiryDate).valueOf() - 4*60000)  <  new Date() ;

const setTokenData = (
  token: string,
  tokenExpiryDate: string,
  refreshTokenNum: string,
  refreshTokenExpiryDate: string
) => {
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("tokenExpiryDate", tokenExpiryDate);
  sessionStorage.setItem("refreshTokenNum", refreshTokenNum);
  sessionStorage.setItem("refreshTokenExpiryDate", refreshTokenExpiryDate);
};

export const getTokenData = () => {
  const token = sessionStorage.getItem("token");
  const tokenExpiryDate = sessionStorage.getItem("tokenExpiryDate");
  const refreshTokenNum = sessionStorage.getItem("refreshTokenNum");
  const refreshTokenExpiryDate = sessionStorage.getItem(
    "refreshTokenExpiryDate"
  );
  return {
    token,
    tokenExpiryDate,
    refreshTokenNum,
    refreshTokenExpiryDate,
  };
};

export const resetTokenData = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("tokenExpiryDate");
  sessionStorage.removeItem("refreshTokenNum");
  sessionStorage.removeItem("refreshTokenExpiryDate");
};

export const isUserAuthExpired = () => {
  const { token, tokenExpiryDate } = getTokenData();

  if (!(token && tokenExpiryDate)) return true;
  return isTokenExpired(tokenExpiryDate);
};

const dal = {
  post: async (url: string, params: any) => {
    const token = await getToken();
    const body = { ...params };
    body.tokenNum = token;
    return await axios.post(url, body);
  },
  get : async(url : string)=>{
    return await axios.get(url);
  }
};


export default dal;
